import React from 'react';
import { PropTypes } from 'prop-types';
import { toast } from 'react-toastify';
import { push } from 'react-router-redux';

import { CRUD } from './queries';
import I18N from '../../common/i18n';
import { withApolloAsyncLoad, getSectionLinkBody } from '../../../base/utils';
import { store } from '../../..';
import { 
  Sections, 
  // AppSections 
} from '../../common/enums';
import CourierForm from './CourierForm';


export default
class CourierEdit extends React.PureComponent {
  static title = I18N.COURIERS_EDIT_TITLE

  static propTypes = {
    itemId: PropTypes.number.isRequired,
    manifestId: PropTypes.number,
    orgId: PropTypes.number,
  }

  _update = (update, data) => {
    const p = update({
      variables: {
        id: this.props.itemId,
        data: data
      }
    });
    p.then((res) => {
      toast.success(`${I18N.COURIERS_EDIT_TITLE}. ${I18N.NOTIFY_SUCCESS}`);
      store.dispatch(push(
        `${getSectionLinkBody(this.props.manifestId)}${Sections.COURIERS}/${res.data.result.id}`
      ));
    });
    p.catch((res) => {
      toast.error(`${I18N.COURIERS_EDIT_TITLE}. ${I18N.NOTIFY_ERROR}`);
      console.log('update error');
    });
    return p;
  }

  _renderForm = (courier) => (
    CRUD.UPDATE(
      {},
      (update) => (
        <CourierForm
          submitText={I18N.SUBMIT_SAVE}
          item={courier}
          {...this.props}
          manifestId={this.props.manifestId || -this.props.orgId}
          submit={(data) => this._update(update, data)} />
      )
    )
  );

  render() {
    return (
      CRUD.GET_ONE(
        {id: this.props.itemId},
        (result) => withApolloAsyncLoad(this._renderForm, result)
      )
    );
  }
}
